export default {"src":"/_next/static/media/fingerprint-dark.79f12d58.svg","height":700,"width":500,"blurWidth":0,"blurHeight":0};